import { render, staticRenderFns } from "./ProblemResolution.vue?vue&type=template&id=456abf8b&scoped=true"
import script from "./ProblemResolution.vue?vue&type=script&lang=js"
export * from "./ProblemResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456abf8b",
  null
  
)

export default component.exports